export default {
	props: {
		autoSignOut:{
			type:Boolean,
			default:true,
		}
	},
	data(){
		return {}
	},
	watch: {
		//
	},
	methods: {
		init(){
			let self = this;
			FB.getLoginStatus(function(response) {   // Called after the JS SDK has been initialized.
				self.onStatusChange(response);        // Returns the login status.
			});
		},
		onSignIn(){
			let self = this;
			FB.login(function(response) {
				self.onStatusChange(response, 'login');
			}, {scope: 'public_profile,email', auth_type:'rerequest'});
		},
		onSignOut(){
			let self = this;
			FB.logout(function(response) {
				//console.log('User signed out.');
			});
		},
		onStatusChange(response) {
			let self = this;
			if (response.status === 'connected') {
				FB.api('/me?fields=name,first_name,last_name,email', function(response) {
					self.$emit('success', {
						'name': response.name ? response.name : '',
						'email': response.email ? response.email : '',
						'first_name': response.first_name ? response.first_name : '',
						'last_name': response.last_name ? response.last_name : '',
					});
				});
				if(self.autoSignOut){
					self.onSignOut();
				}
			}
		},
	},
	mounted(){
		let self = this;
		ITTI.defer(function (){
			self.init();
		}, ['facebookJSSDK']);
	},
	template: `
<a class="sign-in-btn-facebook" @click="onSignIn"></a>
`,
}

/*
FB.getLoginStatus(function(response) {
Response objects
{
status: 'connected',
authResponse: {
		accessToken: '{access-token}',
		expiresIn:'{unix-timestamp}',
		reauthorize_required_in:'{seconds-until-token-expires}',
		signedRequest:'{signed-parameter}',
		userID:'{user-id}'
}
}
if (response.status === 'connected') {
// The user is logged in and has authenticated your
// app, and response.authResponse supplies
// the user's ID, a valid access token, a signed
// request, and the time the access token
// and signed request each expire.
var uid = response.authResponse.userID;
var accessToken = response.authResponse.accessToken;
} else if (response.status === 'not_authorized') {
// The user hasn't authorized your application.  They
// must click the Login button, or you must call FB.login
// in response to a user gesture, to launch a login dialog.
} else {
// The user isn't logged in to Facebook. You can launch a
// login dialog with a user gesture, but the user may have
// to log in to Facebook before authorizing your application.
}
});
*/

